import { useEffect } from "react";
import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { useFiles } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile/hooks/useFiles";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Form } from "@circle-react-uikit/Form";
import { Radio } from "@circle-react-uikit/Radio";

const i18nRoot = "courses.edit.lesson.default_tab";

export const DefaultTabField = () => {
  const { count: filesCount } = useFiles();
  const { control, setValue } = useFormContext();
  const isCommentsEnabled = useWatch({ name: "comments_enabled" });
  const selectedTab = useWatch({ name: "default_tab" });
  const hasFiles = filesCount > 0;

  const DefaultTabOptions = [
    {
      label: t([i18nRoot, "options.comments"]),
      value: "comments",
      disabled: !isCommentsEnabled,
    },
    {
      label: t([i18nRoot, "options.curriculum"]),
      value: "curriculum",
      disabled: false,
    },
    {
      label: t([i18nRoot, "options.files"]),
      value: "files",
      disabled: !hasFiles,
    },
  ];

  useEffect(() => {
    if (!isCommentsEnabled && selectedTab === "comments") {
      setValue("default_tab", "curriculum");
    }
  }, [isCommentsEnabled, selectedTab]);

  const renderRadioGroup = ({ field: { onChange, value } }) => (
    <RadioGroup value={value} onChange={onChange}>
      {DefaultTabOptions.map(({ label, value, disabled }) => (
        <TippyV2
          interactive={false}
          content={t([i18nRoot, `tab_disabled.${value}`])}
          key={value}
          disabled={!disabled}
          arrow={false}
          placement="top"
        >
          <RadioGroup.Option
            value={value}
            disabled={disabled}
            className={classNames(disabled && "opacity-50", "mt-3")}
          >
            {({ checked }) => (
              <Radio
                id={`${label}-radio-${value}`}
                label={label}
                checked={checked}
                className="!text-darkest !ring-secondary dark:!bg-primary"
                labelClassName="m-0 !font-medium text-sm"
                labelWrapperClassName="ml-3 w-full"
              />
            )}
          </RadioGroup.Option>
        </TippyV2>
      ))}
    </RadioGroup>
  );

  return (
    <div className="form-group">
      <label className="form-group__label text-dark flex cursor-default">
        <span>{t([i18nRoot, "title"])}</span>
      </label>
      <Form.Item
        id="default_tab"
        name="default_tab"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Controller control={control} render={renderRadioGroup} />
      </Form.Item>
    </div>
  );
};
